import { defineSlotRecipe } from '@chakra-ui/react';
import { fieldAnatomy } from '@chakra-ui/react/anatomy';

export const fieldSlotRecipe = defineSlotRecipe({
  className: 'chakra-field',
  slots: fieldAnatomy.keys(),
  variants: {
    variant: {
      searchForm: {
        label: {
          color: 'white'
        },
        errorText: {
          color: '#ff6e4f',
          fontSize: 'md'
        }
      }
    }
  }
});
